import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import '@fontsource-variable/dm-sans'
import '@fontsource-variable/outfit'
import './index.css'
import { isLovablePreviewContext, registerPushServiceWorker, unregisterPreviewServiceWorkers } from './lib/pushServiceWorker.ts'
import './lib/isMedianApp.ts'
import { registerPullToRefreshHaptic } from './lib/haptics.ts'

registerPullToRefreshHaptic();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

const scheduleAfterFirstPaint = (callback: () => void) => {
  const runWhenIdle = () => {
    window.setTimeout(() => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 5000 });
        return;
      }

      callback();
    }, 8000);
  };

  if (document.readyState === 'complete') {
    runWhenIdle();
  } else {
    window.addEventListener('load', runWhenIdle, { once: true });
  }
};

if ('serviceWorker' in navigator) {
  scheduleAfterFirstPaint(() => {
    if (!import.meta.env.PROD || isLovablePreviewContext()) {
      unregisterPreviewServiceWorkers().catch((error) => {
        console.warn('Unable to unregister preview service workers:', error);
      });
    } else {
      registerPushServiceWorker().catch((error) => {
        console.warn('Unable to register push service worker:', error);
      });
    }
  });
}
